import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import { baseUrl } from '../config/env'

const state = {
	token: '',
	userInfo: {
		id:'',
		userbh: '',
		username: '',
		token:''
	},
	dynamicRouter:false,//是否加载路由
	options: [],//tab菜单
	activeIndex: '/',
	topNavState: 'sys_home',
  leftNavState: 'sys_home',
	topNavPath:'/',
	upBaseUrl: baseUrl,
	imgBaseUrl: baseUrl +'coupon-merch/',
}

const mutations = {
	//保存用户信息 更新
	saveUserInfo(state, userInfo){
		state.userInfo = userInfo;
		window.sessionStorage.setItem("userbh",userInfo.userbh);
		window.sessionStorage.setItem("username",userInfo.username);
		window.sessionStorage.setItem("token",userInfo.token);
	},
	saveMerchInfo(state, userInfo){
		state.userInfo = {'userbh':userInfo.lbh,'username':userInfo.merchname,'token':userInfo.token,'id':userInfo.id};
		window.sessionStorage.setItem("userbh",userInfo.merchno);
		window.sessionStorage.setItem("username",userInfo.merchname);
		window.sessionStorage.setItem("token",userInfo.token);
	},
	saveDynamicRouter(state, dynamicRouter){
		state.dynamicRouter = dynamicRouter;
	},
	//保存token信息 更新
	saveToken(state, token){
		state.token = token;
	},
	// 添加tabs
  add_tabs (state, data) {
    this.state.options.push(data);
  },
  // 删除tabs
  delete_tabs (state, route) {
    let index = 0;
    for (let option of state.options) {
      if (option.route === route) {
        break;
      }
      index++;
    }
    this.state.options.splice(index, 1);
  },
  // 设置当前激活的tab
  set_active_index (state, index) {
    this.state.activeIndex = index;
  },
  // 设置详情信息
  save_detail_info (state, info) {
    this.state.userInfo = info;
  }
}

const actions = {
	//保存用户信息
	async saveUserInfo({commit},userInfo){
		try{
			commit('saveUserInfo', userInfo);
		}catch(err){
			//console.log(err.message)
		}
	},
	async saveMerchInfo({commit},userInfo){
		try{
			commit('saveMerchInfo', userInfo);
		}catch(err){
			//console.log(err.message)
		}
	},
	//保存token信息
	async saveToken({commit},token){
		try{
			commit('saveToken', token);
		}catch(err){
			//console.log(err.message)
		}
	},
	//保存动态路由状态
	async saveDynamicRouter({commit},dynamicRouter){
		try{
			commit('saveDynamicRouter', dynamicRouter);
		}catch(err){
			//console.log(err.message)
		}
	}
}

export default new Vuex.Store({
	state,
	actions,
	mutations,
})



// WEBPACK FOOTER //
// ./src/store/index.js